import { AccountcategoryTableDataType } from "../AccountCategory/types";

export type SearchParamsType = {
  filter: {
    status: number;
    searchText: string;
    categoryId: number;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  tagId: number;
  tagCode: string;
  tagName: string;
  createdDate: string;
  categoryId: number;
  createdByUserId: number;
  tagStatus: number;
  categoryName: string;
  tagClinicId: number;
};

export type MasterDataType = {
  tagId: number;
  createdByUserId: number;
  tagClinicId: number;
  tagCode: string;
  tagName: string;
  tagStatus: number;
  categoryId: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  tagCode: string;
  tagName: string;
  tagStatus: number;
  category: AccountcategoryTableDataType | null;
};

export const initialFormData: MasterFormDataType = {
  tagCode: "",
  tagName: "",
  tagStatus: 1,
  category: null
};
